module.exports = __webpack_public_path__ + "static/Descartes Underwriting-3ecc01db6550442d17227952d39eddfe.jpg";